import React from 'react';
import * as AuthenticationStore from 'store/redux/Authentication';
import { connect } from 'react-redux';
import { ApplicationState } from 'store/redux';

import { authenticationServiceFactory } from 'services/authenticationService';
import Panel from './Panel';
import Profile from './Profile';
import Context from 'configuration/context';
import { UserState } from 'store/redux/Authentication';
import { ISiteReference, IUserInRole } from 'pages/Login';

const ProfilePanel = (props: Props) => {
  if (!props.open) return null;

  return (
    <Panel onClose={props.onClose}>
      <Profile
        OnLogout={props.onLogout}
        OnClose={props.onClose}
        OnActiveCustomerSelect={(site: ISiteReference) => {
          if (props.setLoginState) {
            props.setLoginState({
              RequestedCustomerId: site.customerId.toString(),
            });
            if (!props.authenticationState) {
              throw new Error('authentication state cannot be undefined after login');
            }
            props.authenticationState.RequestedCustomerId = site.customerId.toString();
            props.authenticationState &&
              props.authenticationState.AccessToken &&
              authenticationServiceFactory(
                Context.APIUrl,
                { setLoginState: props.setLoginState },
                props.authenticationState
              )
                .fetchUserDetails(props.authenticationState.AccessToken, site.customerId.toString())
                .then((userInRole: IUserInRole) => {
                  props.setLoginState &&
                    props.setLoginState({
                      UserInRole: userInRole,
                    });
                });
          }
        }}
      />
    </Panel>
  );
};

type Props = Partial<typeof AuthenticationStore.actions> & {
  authenticationState?: UserState;
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
};

export default connect(
  (state: ApplicationState, ownProps: Props) => ({
    userState: state.authentication,
  }),
  AuthenticationStore.actions
)(ProfilePanel);
